import { connect } from 'react-redux';
import { getBlogDetail, getBlogs_byCat } from '../../store/blogReducer';
import ListNewUpdate from './newupdateBlog';


const mapStateToProps = state => ({
  blogLoading: state.blogMT.blogLoading,
  blogs: state.blogMT.blogs,
  blogDetail: state.blogMT.blogDetail,
});

const mapDispatchToProps = dispatch => ({
  getBlogs_byCat: (lang, category, limit)=> dispatch(getBlogs_byCat(lang, category,limit)),
  getBlogDetail: id => dispatch(getBlogDetail(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ListNewUpdate);


// WEBPACK FOOTER //
// ./src/components/common/newupdate.jsx